import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../styles/diario.scss';
import moment from 'moment';

const Renuncia = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchRenuncias()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Header><h5>{props.renuncia.nome} / {props.renuncia.cnpj}</h5></Card.Header>
                    <Card.Body>
                        <p>Vigência: até {moment(props.renuncia.vigencia).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</p>
                        <p>Setor: {props.renuncia.setor}</p>
                        <p>Espécie: {props.renuncia.especie}</p>
                        {props.renuncia.produto ? <p>Produto: {props.renuncia.especie}</p> : null}
                        <p>Contrapartida: {props.renuncia.contrapartida}</p>
                        <p>Impacto Obitido/Esperado: {props.renuncia.impacto}</p>
                        <p>Valor: {props.renuncia.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.renuncia._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.renuncia._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Renuncia;